import icon from 'vue-svgicon';

icon.register({
    'regular/graph-stats': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M.75 11.75h3.5a1.5 1.5 0 0 0 1.385-.923l2.6-6.115a.75.75 0 0 1 1.4.051l4.734 14.725a.75.75 0 0 0 1.4.051l2.595-6.866a1.5 1.5 0 0 1 1.385-.923h3.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
